interface LogoProps {
  variant?: 'dark' | 'light';
  compact?: boolean;
}

export default function Logo({ variant = 'dark', compact = false }: LogoProps) {
  const textColor = variant === 'light' ? 'text-background-50' : 'text-foreground-950';
  const iconBg = variant === 'light' ? 'bg-primary-500/20' : 'bg-primary-100';
  const iconColor = variant === 'light' ? 'text-primary-300' : 'text-primary-500';

  return (
    <div className="flex items-center gap-2.5 cursor-pointer select-none">
      <div className={`relative w-10 h-10 flex items-center justify-center rounded-xl ${iconBg}`}>
        <i className={`ri-heart-pulse-line ${iconColor} text-2xl w-6 h-6 flex items-center justify-center`} />
      </div>
      {!compact && (
        <span className={`font-heading font-semibold text-[1.35rem] tracking-tight leading-none ${textColor}`}>
          medica<span className="text-primary-500">clic</span>
        </span>
      )}
    </div>
  );
}